import React from 'react';

import { closedFundMessage } from '../../../../../store/product/normalizer';
import { ProductButtonProps } from '../../../../BatchTicket/components/DynamicButton';
import { ApplicationButton } from '../../components/ApplicationButton';

export const FundsSellButton: React.FC<ProductButtonProps<'fundsSell'>> = (props) => {
  const isDisabled = props.offer.closedFundNormalized;
  const tooltip = isDisabled ? closedFundMessage : undefined;

  return (
    <ApplicationButton
      {...props}
      idSelector="productIdNormalized"
      buttonText="Resgatar"
      buttonVariant="secondary"
      buttonColor="neutral.darkest"
      backgroundColor="neutral.white"
      isDisabled={isDisabled || props.isDisabled}
      tooltip={tooltip}
    />
  );
};
